<template>
  <NuxtLayout :name="layout" class="font-mono">
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
const layout = 'desktop'
</script>
